/* Original Relvie code. No trackers, dependencies, cart writes or checkout events. */
(() => {
  const trackingKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];
  function initialize(root) {
    if (!root || root.dataset.rlpReady) return;
    root.dataset.rlpReady = 'true';
    const incoming = new URLSearchParams(window.location.search);
    root.querySelectorAll('[data-rlp-product-link]').forEach(link => {
      const destination = new URL(link.getAttribute('href'), window.location.href);
      for (const key of trackingKeys) {
        const value = incoming.get(key);
        if (value) destination.searchParams.set(key, value);
      }
      destination.searchParams.set('relvie_lander', root.dataset.rlpId);
      link.href = destination.href;
      link.addEventListener('click', () => {
        root.dispatchEvent(new CustomEvent('relvie:lander_click', {
          bubbles: true,
          detail: { landerId: root.dataset.rlpId, placement: link.dataset.rlpPlacement }
        }));
      });
    });
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    root.querySelectorAll('[data-rlp-motion]').forEach(video => {
      const update = () => {
        if (reducedMotion.matches) { video.autoplay = false; video.pause(); }
        else { video.autoplay = true; video.play().catch(() => {}); }
      };
      update();
      reducedMotion.addEventListener('change', update);
    });
  }
  const scan = () => document.querySelectorAll('[data-rlp]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
